import React from "react";
import Image from "./Image";
import Heroicon from "../Heroicon";

function PodcastSummary({ selectedPodcast }) {
  return (
    <div className="flex flex-col sm:flex-row gap-6 p-5 md:p-7">
      <Image
        src={selectedPodcast.image}
        className="w-full h-auto object-cover sm:w-32 sm:h-32"
      />
      <div className="flex-1">
        <h2 className="text-purple-600 text-xl md:text-2xl font-sans font-bold">
          Podcast Details
        </h2>

        {(selectedPodcast.description ?? false) && (
          <>
            <h3 className="eyebrow-xs eyebrow sm:eyebrow-sm mt-4 font-sans">
              Title
            </h3>
            <p className="mt-1 text-gray-800">{selectedPodcast.title}</p>
          </>
        )}

        {(selectedPodcast.description ?? false) && (
          <>
            <h3 className="eyebrow-xs eyebrow sm:eyebrow-sm mt-4 font-sans">
              Description
            </h3>
            <p className="line-clamp-3 mt-1 text-gray-800 font-sans overflow-wrap-anywhere">
              {selectedPodcast.description}
            </p>
          </>
        )}

        {(selectedPodcast.ownerName ?? false) && (
          <>
            <h3 className="eyebrow-xs eyebrow sm:eyebrow-sm mt-4 font-sans">
              Owner
            </h3>
            <p className="capitalize mt-1 text-gray-800">
              {selectedPodcast.ownerName.toLowerCase()}
            </p>
          </>
        )}

        {(selectedPodcast.episodeCount ?? false) && (
          <>
            <h2 className="text-purple-600 text-xl md:text-2xl mt-4 font-sans font-bold">
              Episodes
            </h2>
            <p className="mt-3 text-gray-800">
              We found{" "}
              <span className="badge badge--primary">
                {selectedPodcast.episodeCount} episode
                {selectedPodcast.episodeCount !== 1 && "s"}
              </span>{" "}
              ready to import.
            </p>
            <div className="mt-3 p-2 bg-gray-100 text-gray-800 flex items-center justify-between rounded-md">
              <p className="flex text-xs sm:text-sm items-center">
                <Heroicon
                  icon="o-exclamation-circle"
                  style="mr-1 w-6 h-6 block text-gray-400"
                />{" "}
                Expecting a different number of episodes?
              </p>
              <a
                className="btn-solid flex items-center text-xs text-gray-600 bg-gray-300 hover:bg-gray-200 focus:ring-gray-100 focus:border focus:border-gray-400"
                target="_blank"
                rel="noopener"
                href="https://support.castos.com/article/293-my-rss-feed-is-missing-episodes"
              >
                Get Help
                <Heroicon
                  icon="o-arrow-up-right"
                  style="ml-1 h-3 w-3 block text-gray-600"
                />
              </a>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default PodcastSummary;
